import {APIResponse, easasAxios} from "../services/HttpService";
import {DatasetDataLagLeadRequest, UpdateDatasetData} from "./model/requests";
import {DatasetDataInfoOptions, DatasetDataInfoResponse} from "./model/dataset/DatasetDataInfoResponse";
import {IUsersDataInfoResponse} from "./model/user/UsersDataInfoResponse";
import {ILicenseDataInfo} from "./model/user/ILicenseDataInfo";
import {ApiDefinition} from "./ApiDefinition";

export class DatasetDataApiDefinition extends ApiDefinition {
    constructor() {
        super("/datasetData");
    }

    async getDataInfo(identifiers: Array<string>, config?: DatasetDataLagLeadRequest): Promise<APIResponse<Array<DatasetDataInfoResponse>>> {
        try {
            const {data} = await this.post<Array<DatasetDataInfoResponse>, any>(`/dashboard/datasets/dataInfo`, {...config, identifiers});
            return {data}
        } catch (error: any) {
            console.error(error);
            return {error};
        }
    }

    async getRecentData(identifiers: string[], options?: DatasetDataInfoOptions): Promise<APIResponse<DatasetDataInfoResponse[]>> {
        if (!identifiers.length || identifiers.every(identifier => identifier === null || identifier === undefined)) {
            return {data: []};
        }
        try {
            const {data} = await this.post<DatasetDataInfoResponse[], string[]>(`/dataInfoRecent`, identifiers, {params: {...options}});
            return {data};
        } catch (error: any) {
            console.error(error);
            return {error};
        }
    }

    async updateData(UpdateDatasetDataArray: Array<UpdateDatasetData>) {
        try {
            const {data} = await this.post(`/update`, UpdateDatasetDataArray);
            return {data}
        } catch (error: any) {
            console.error(error);
            return {error};
        }
    }

    async getDataInfoRange(
        identifiers: Array<string>,
        timeStart: string,
        timeEnd?: string,
        downsampleInterval?: number // seconds
    ): Promise<APIResponse<Array<DatasetDataInfoResponse>>> {
        //Add 1 seconds to timeEnd time, to get the last datapoint
        let timeEndTemp = timeEnd ? timeEnd : timeStart;
        let timeEndPlusOneS = new Date(new Date(timeEndTemp).getTime() + 1000).toISOString();

        let params = {
            from: timeStart,
            to: timeEndPlusOneS,
            downsampleInterval
        }

        return this.post(`/dataInfoRange`, identifiers, {params});
    }

    async getUsers(permission?: string) {
        try {
            let props: string = "/users";
            if (permission) {
                props = props + "?hasPermission=" + permission;
            }
            const {data} = await easasAxios.get<Array<IUsersDataInfoResponse>>(props);
            return {data}
        } catch (error: any) {
            console.error(error);
            return {error};
        }
    }

    async getLicenses() {
        try {
            const {data} = await easasAxios.get<Array<ILicenseDataInfo>>("/licences/licences")
            return {data}
        } catch (error: any) {
            console.error(error);
            return {error};
        }
    }

    async clearDatasetData(queryData:{
        identifiers: Array<String>,
        timeStart: string,
        timeEnd: string,
        clearAll: boolean
    }) {
        try {
            const params = {
                from: queryData.timeStart,
                to: queryData.timeEnd,
                all: queryData.clearAll
            }

            await this.post(`/clearData`, queryData.identifiers, {params});
            return {};
        } catch (error) {
            console.error(error);
            return {error};
        }
    }

}

export const DatasetDataApi = new DatasetDataApiDefinition();
